var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyclesStatesColumnDoubleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.20843L3.44003 9.58882L8.16093 3.86536L7.22741 3L3.27018 7.79761L1.25128 6.1629L0.5 7.20843ZM11.5 3.86536L10.5665 3L6.61855 7.78643L6.15179 7.39058L5.37696 8.4177L6.7698 9.6L11.5 3.86536Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclesStatesColumnDoubleCheck);
export default __webpack_public_path__ + "9c645b9f21fb019ac5f1a648e0cd5e7e.svg";
export { ForwardRef as ReactComponent };